export default {
  badge: 'Placa',
  open: 'Abrir',
  close: 'Cerrar',
  dismiss: 'Descartar',
  confirmEdit: {
    ok: 'OK',
    cancel: 'Cancelar',
  },
  dataIterator: {
    noResultsText: 'Ningún elemento coincide con la búsqueda',
    loadingText: 'Cargando...',
  },
  dataTable: {
    itemsPerPageText: 'Filas por página:',
    ariaLabel: {
      sortDescending: 'Orden descendente.',
      sortAscending: 'Orden ascendente.',
      sortNone: 'Sin ordenar.',
      activateNone: 'Pulse para quitar orden.',
      activateDescending: 'Pulse para ordenar de forma descendente.',
      activateAscending: 'Pulse para ordenar de forma ascendente.',
    },
    sortBy: 'Ordenado por',
  },
  dataFooter: {
    itemsPerPageText: 'Elementos por página:',
    itemsPerPageAll: 'Todos',
    nextPage: 'Página siguiente',
    prevPage: 'Página anterior',
    firstPage: 'Primera página',
    lastPage: 'Última página',
    pageText: '{0}-{1} de {2}',
  },
  dateRangeInput: {
    divider: 'a',
  },
  datePicker: {
    itemsSelected: '{0} seleccionados',
    range: {
      title: 'Seleccionar fechas',
      header: 'Introducir fechas',
    },
    title: 'Seleccionar fecha',
    header: 'Introducir fecha',
    input: {
      placeholder: 'Introducir fecha',
    },
    ariaLabel: {
      previousMonth: 'Mes anterior',
      nextMonth: 'Mes siguiente',
      selectYear: 'Seleccionar año',
      previousYear: 'Año anterior',
      nextYear: 'Año siguiente',
      selectMonth: 'Seleccionar mes',
      selectDate: '{0}',
      currentDate: 'Hoy, {0}',
    },
  },
  noDataText: 'No hay datos disponibles',
  carousel: {
    prev: 'Visual anterior',
    next: 'Visual siguiente',
    ariaLabel: {
      delimiter: 'Visual {0} de {1}',
    },
  },
  calendar: {
    moreEvents: '{0} más',
    today: 'Hoy',
  },
  input: {
    clear: 'Borrar {0}',
    prependAction: '{0} acción adelantada',
    appendAction: '{0} acción añadida',
    otp: 'Por favor, introduzca el carácter OTP {0}',
  },
  fileInput: {
    counter: '{0} archivos',
    counterSize: '{0} archivos ({1} en total)',
  },
  fileUpload: {
    title: 'Arrastra y suelta archivos aquí',
    divider: 'o',
    browse: 'Explorar archivos',
  },
  timePicker: {
    am: 'AM',
    pm: 'PM',
    title: 'Seleccionar hora',
    hour: 'Hora',
    minute: 'Minutos',
    second: 'Segundos',
    notAllowed: 'El valor no está permitido',
  },
  pagination: {
    ariaLabel: {
      root: 'Navegación de paginación',
      next: 'Página siguiente',
      previous: 'Página anterior',
      page: 'Ir a la página {0}',
      currentPage: 'Página actual, página {0}',
      first: 'Primera página',
      last: 'Última página',
    },
  },
  stepper: {
    next: 'Siguiente',
    prev: 'Anterior',
  },
  rating: {
    ariaLabel: {
      item: 'Puntuación {0} de {1}',
    },
  },
  loading: 'Cargando...',
  infiniteScroll: {
    loadMore: 'Cargar más',
    empty: 'No hay más',
  },
  rules: {
    required: 'Este campo es obligatorio',
    email: 'Por favor, introduce un correo electrónico válido',
    number: 'Este campo solo puede contener números',
    integer: 'Este campo solo puede contener valores enteros',
    capital: 'Este campo solo puede contener letras mayúsculas',
    maxLength: 'Debes introducir un máximo de {0} caracteres',
    minLength: 'Debes introducir un mínimo de {0} caracteres',
    strictLength: 'La longitud del campo introducido no es válida',
    exclude: 'El carácter {0} no está permitido',
    notEmpty: 'Por favor, elige al menos un valor',
    pattern: 'Formato inválido',
  },
  command: {
    search: 'Escribe un comando o busca...',
  },
  hotkey: {
    then: 'luego',
    ctrl: 'Ctrl',
    command: 'Command',
    shift: 'Shift',
    alt: 'Alt',
    option: 'Option',
    enter: 'Intro',
    escape: 'Escape',
    upArrow: 'Flecha arriba',
    downArrow: 'Flecha abajo',
    leftArrow: 'Flecha izquierda',
    rightArrow: 'Flecha derecha',
    backspace: 'Retroceso',
    space: 'Espacio',
    plus: 'más',
    shortcut: 'Atajo de teclado: {0}',
    or: 'o',
  },
  video: {
    play: 'Reproducir',
    pause: 'Pausa',
    seek: 'Buscar',
    volume: 'Volumen',
    showVolume: 'Mostrar control de volumen',
    mute: 'Silenciar',
    unmute: 'Activar sonido',
    enterFullscreen: 'Pantalla completa',
    exitFullscreen: 'Salir de pantalla completa',
  },
  colorPicker: {
    ariaLabel: {
      eyedropper: 'Seleccionar color de la pantalla',
      hueSlider: 'Tono',
      alphaSlider: 'Alfa',
      redInput: 'Rojo',
      greenInput: 'Verde',
      blueInput: 'Azul',
      alphaInput: 'Alfa',
      hueInput: 'Tono',
      saturationInput: 'Saturación',
      lightnessInput: 'Luminosidad',
      hexInput: 'Valor HEX',
      hexaInput: 'Valor HEX con alfa',
      changeFormat: 'Cambiar formato de color',
    },
  },
}
